<template>
  <div class="editCubeRichText">
    <div>{{title}} <button v-if="!edit" class="editBtn" @click="edit=true"></button></div>
    <p v-if="!edit&&data" v-html="data?data.replaceAll('\n', '<br>'):''"></p>
    <!-- <textarea v-else v-model="data" :disabled="!edit"/> -->
    <QuillEditor v-else  v-model="data"
                ref="myQuillEditor"
                :options="editorOption"/>
    <div class="btns" v-if="edit">
      <button class="cancel" @click="edit=false">取消</button>
      <button class="confirm" @click="udpateData">儲存</button>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor as QuillEditor } from 'vue-quill-editor'
import { getapi, postapi } from '../store/fetch'
export default {
  props: ['keyname', 'title', 'editorOption'],
  components: {
    QuillEditor
  },
  data () {
    return {
      edit: false,
      data: null
    }
  },
  async mounted () {
    this.getdata()
  },
  methods: {
    async getdata () {
      this.data = await getapi(`selections/${this.keyname}`)
    },
    async udpateData () {
      this.data = await postapi(`selections/${this.keyname}`, { key: 'value', data: this.data })
      this.edit = false
    }
  }
}
</script>
<style lang="scss">
.editCubeRichText {
  * {
    font-family: unset;
  }
  em {
    font-style: italic;
  }
  strong {
    font-weight: 700;
  }
  .ql-container {
      height: fit-content;
  }
  .ql-editor {
    height: fit-content;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    letter-spacing: 0.1em;
    color: #848484;

  p {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    letter-spacing: 0.1em;
    color: #848484;
  }
  h1 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 162%;
    color: var(--color-checked);
    text-align: start;
  }
  h2 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 162%;
    color: var(--color-checked);
  }
  .ql-size-small {
    font-size: small;
  }
  .ql-size-large {
    font-size: larger;
  }
  .ql-size-huge {
    font-size: xx-large;
  }
  }
  .ql-size-large { font-size: large; }
  .ql-align-center {
    text-align: center;
  }
  img {
    width: 100%;
  }
  .ql-indent-2 {
    text-indent: 2em;
  }
  .ql-indent-1 {
    text-indent: 1em;
  }
}
</style>

<style lang="scss" scoped>
.editCubeRichText {
  margin: 0;
  margin-bottom: 20px;
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 17px;
  textarea, p {
    border-radius: 3px;
    margin: 0;
    padding: 7px 20px;
    border: 1px solid var(--color-border);
    min-height: 200px;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: -webkit-fill-available;
  }
  &>div:nth-child(1) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(/pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}

</style>
